import { useTheme, type ThemeMode } from '../lib/theme';

const OPTIONS: { value: ThemeMode; label: string; icon: string }[] = [
  { value: 'light', label: 'Aydınlık', icon: '☀' },
  { value: 'dark', label: 'Karanlık', icon: '☾' },
  { value: 'system', label: 'Sistem', icon: '⌘' },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <div
      role="group"
      aria-label="Tema"
      className="inline-flex rounded-md bg-slate-100 p-0.5 ring-1 ring-slate-200 dark:bg-slate-800 dark:ring-slate-700"
    >
      {OPTIONS.map((o) => {
        const active = mode === o.value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            title={o.label}
            onClick={() => setMode(o.value)}
            className={
              'flex h-7 w-7 items-center justify-center rounded text-sm transition ' +
              (active
                ? 'bg-white text-brand-700 shadow-sm dark:bg-slate-700 dark:text-brand-200'
                : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200')
            }
          >
            <span aria-hidden="true">{o.icon}</span>
            <span className="sr-only">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
